// @ts-expect-error
// eslint-disable-next-line import/no-duplicates
import LogoSquareURL from './raw.noindex/logo-square.svg';
// @ts-expect-error
// eslint-disable-next-line import/no-duplicates
import LogoSquareComponent from './raw.noindex/logo-square.svg?react';
// @ts-expect-error
// eslint-disable-next-line import/no-duplicates
import LogoRectURL from './raw.noindex/logo-rect.svg';
// @ts-expect-error
// eslint-disable-next-line import/no-duplicates
import LogoRectComponent from './raw.noindex/logo-rect.svg?react';
import LottieEmptyStateJSON from './raw.noindex/lottie-empty-state.json';
// @ts-expect-error
// eslint-disable-next-line import/no-duplicates
import LinkedInURL from './raw.noindex/linkedin.svg';
// @ts-expect-error
// eslint-disable-next-line import/no-duplicates
import LinkedInComponent from './raw.noindex/linkedin.svg?react';
// @ts-expect-error
// eslint-disable-next-line import/no-duplicates
import XURL from './raw.noindex/x.svg';
// @ts-expect-error
// eslint-disable-next-line import/no-duplicates
import XComponent from './raw.noindex/x.svg?react';
// @ts-expect-error
// eslint-disable-next-line import/no-duplicates
import ThreadsURL from './raw.noindex/threads.svg';
// @ts-expect-error
// eslint-disable-next-line import/no-duplicates
import ThreadsComponent from './raw.noindex/threads.svg?react';

export const assets = {
  LogoSquare: {
    url: LogoSquareURL,
    Component: LogoSquareComponent,
  },
  LogoRect: {
    url: LogoRectURL,
    Component: LogoRectComponent,
  },
  LottieEmptyState: {
    json: LottieEmptyStateJSON,
  },
  LinkedIn: {
    url: LinkedInURL,
    Component: LinkedInComponent,
  },
  X: {
    url: XURL,
    Component: XComponent,
  },
  Threads: {
    url: ThreadsURL,
    Component: ThreadsComponent,
  },
};
